<template>
    <div class="input"
         :class="[
            {'input--active': !empty && !disabled},
            {'input--disabled': disabled }
         ]">
    <!-- <div class="input"
         :class="[
            {'input--active': errored},
            {'input--error': !errored},
            {'input--disabled': disabled }
         ]"> -->
        <form>
            <label class="input__label" for="name">{{ title }}</label>
            <!-- <div class="input__block" :class="{'input__block--check': true}"> -->
            <div class="input__block">

                <!-- Two blocks because of empty mask... -->
                <!-- https://github.com/vuejs-tips/vue-the-mask/pull/34 -->
                <!-- https://github.com/vuejs-tips/vue-the-mask/issues/82 -->
                <input
                    v-if="mask"
                    v-model="inputValue"
                    class="input__main"
                    :type="type"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    :autocomplete="autocomplete"
                    :autocapitalize="autocapitalize"
                    v-mask="mask"
                    v-on:keydown.enter.prevent=""
                />
                <input
                    v-else
                    v-model="inputValue"
                    class="input__main"
                    :type="type"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    :autocomplete="autocomplete"
                    :autocapitalize="autocapitalize"
                    v-on:keydown.enter.prevent=""
                />
                <div class="input__validate">
                    <p>{{ errorMessage }}</p>
                </div>
                <div v-if="validated" class="input__check">
                    <checkWhiteIcon></checkWhiteIcon>
                </div>
                <!-- <div v-if="validated" class="input__check input__check--error">
                    <errorCheckIcon></errorCheckIcon>
                </div> -->
                <div v-if="disabled" class="input__check input__check--lock">
                    <checkLockIcon></checkLockIcon>
                </div>
            </div>
        </form>
    </div>
    
</template>



<script>

    import checkIcon from '@/assets/svg/check.svg';
    import errorCheckIcon from '@/assets/svg/error-check.svg';
    import checkWhiteIcon from '@/assets/svg/check-white.svg';
    import checkLockIcon from '@/assets/svg/lock.svg';

    export default {
        name: 'InputField',
        components: {
            checkIcon,
            errorCheckIcon,
            checkWhiteIcon,
            checkLockIcon
        },
        props: {
            mask: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                required: false,
                default: '',
            },
            placeholder: {
                type: String,
                required: false
            },
            value: {
                type: String,
                required: false,
                default: ''
            },
            errorMessage: {
                type: String,
                required: false,
                default: ''
            },
            type: {
                type: String,
                required: false,
                default: 'text'
            },
            autocomplete: {
                type: String,
                required: false,
                // default: 'text'
            },
            autocapitalize: {
                type: String,
                required: false,
                // default: 'on'
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            errored: {
                type: Boolean,
                required: false,
                default: false
            },
            validated: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                inputValue: '',
                empty: true
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {

                    this.empty = (val.trim() == '');
                    this.inputValue = val;
                }
            },
            inputValue: {
                immediate: true,
                handler(val) {
                    this.$emit('input', val);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InputField.vue?75f8a56e